import Vue from 'vue';
import Inputmask from 'inputmask';
// import 'inputmask/lib/extensions/inputmask.numeric.extensions';

Vue.directive('mask', {
    bind(el, binding) {
        Inputmask(binding.value).mask(el);
    },
});

Vue.directive('scroll-to', {
    bind(el, binding) {
        el.addEventListener('click', () => {
            document.querySelector(binding.value).scrollIntoView({
                behavior: 'smooth',
            });
        });
    },
});
